import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    Optional
} from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import {
    CompleteSortieCommand,
    SortieDto
} from '@flyfreely-portal-ui/flyfreely';
import { Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { MissionFlightLogsDirective } from '../mission-flight-logs.directive';

/**
 * Displays a small summary of the flights (sorties) on a mission, broken
 * down by duration source, along with the number of flight logs attached
 * to the mission that are not yet assigned to a flight.
 */
@Component({
    selector: 'mission-flight-summary',
    templateUrl: './mission-flight-summary.component.html',
    styleUrl: './styles.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MissionFlightSummary implements OnInit, OnDestroy {
    @Input() flights: FormArray<FormControl<CompleteSortieCommand>>;
    @Input() hasFlightLogging = false;

    totalFlights = 0;
    flightsWithLogs = 0;
    timerFlights = 0;
    manualFlights = 0;
    unassignedFlightLogsCount = 0;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        @Optional() private flightLogsData: MissionFlightLogsDirective,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.flights.valueChanges
            .pipe(startWith(this.flights.value), takeUntil(this.ngUnsubscribe$))
            .subscribe(flights => {
                this.totalFlights = flights.length;
                this.flightsWithLogs = flights.filter(
                    f => f.durationSource === SortieDto.DurationSource.LOGS
                ).length;
                this.timerFlights = flights.filter(
                    f => f.durationSource === SortieDto.DurationSource.TIMER
                ).length;
                this.manualFlights = flights.filter(
                    f => f.durationSource === SortieDto.DurationSource.MANUAL
                ).length;
                this.changeDetector.markForCheck();
            });

        if (this.hasFlightLogging && this.flightLogsData != null) {
            this.flightLogsData.flightLogs$
                .pipe(
                    map(
                        logs => logs.filter(log => log.flightId == null).length
                    ),
                    takeUntil(this.ngUnsubscribe$)
                )
                .subscribe(count => {
                    this.unassignedFlightLogsCount = count;
                    this.changeDetector.markForCheck();
                });
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
